import { HttpContext, HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, switchMap, throwError } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../services/notification.service';
import { SKIP_GLOBAL_LOADER } from '../http/http-context-tokens';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const notificationService = inject(NotificationService);
  const transloco = inject(TranslocoService);
  const router = inject(Router);
  const token = authService.getAccessToken();

  if (req.url.includes('/token')) {
    return next(req);
  }

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && authService.getRefreshToken()) {
        return authService.refreshTokenOnce().pipe(
          switchMap(() => {
            const newToken = authService.getAccessToken();
            req = req.clone({
              setHeaders: {
                Authorization: `Bearer ${newToken}`,
              },
              context: req.context.set(SKIP_GLOBAL_LOADER, true),
            });
            return next(req);
          }),
          catchError(() => {
            notificationService.show(
              transloco.translate('notifications.sessionExpired'),
              'warning',
            );
            void router.navigate(['/login']);
            return EMPTY;
          }),
        );
      }

      return throwError(() => error);
    }),
  );
};
